export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/cities/state.js